<template>
    <ContentCard :bg-color="bgColor" :link="url" class="cursor-pointer" :disabled="content.lock" :scheduleContent="scheduleContent">
        <div class="row align-items-center" @click.self="handleContentClick(false)">
            <div class="col-auto nch--content-color" :style="{'color': color.primary}">
                <i class="mdi mdi-36px mdi-notebook"></i>
            </div>
            <div class="col ml-1" :class="content.lock ? 'disabled' : ''">
                <h4 v-if="content.lock" class="nch--content-color">{{content.translation.name}}</h4>
                <h4 v-else class="mb-0">{{content.translation.name}}</h4>
            </div>
            <ContentLock
                v-if="content.lock"
                class="mx-3"
                :message="content.lock_message"
                :color="color.primary"
                :icon="content.lock_type === 'SCHEDULE' && content.exercise_publish.start_date != null ? 'mdi mdi-calendar-clock' : 'mdi mdi-lock-outline'"
            />
            <div v-else class="col-auto" :style="{'color': color.primary}">
                <span
                    @click.prevent.self="handleContentClick(true)"
                    v-if="content.forum"
                    :style="{'color': color.primary}"
                    class="forum"
                    :class="`mdi mdi-forum mdi-36px`"
                ></span>
            </div>
        </div>
        <Modal v-model:show="modal" size="lg" bodyClasses="forum-content-body p-0">
            <Forum :name="content.translation.name" :forum="content.forum" modal @close="modal=false" @click="$event.preventDefault()"/>
        </Modal>
    </ContentCard>
</template>

<script>
import ContentCard from "../../Common/ContentCard";
import ContentLock from "../../ContentComponents/ContentLock";
import Modal from "../../../argon/components/Modal";
import Forum from "../../Forum";

export default {
    name: "ExerciseComponent",
    components: {
        ContentCard,
        ContentLock,
        Modal,
        Forum
    },
    props: {
        content: {
            type: Object,
            required: true
        },
        courseId: {
            type: Number
        },
        moduleId: {
            type: Number
        },
        bgColor: {
            type: String,
            default: "#ececec"
        },
        parentId: Number,
        submodules: Array
    },
    data() {
        return {
            url: null,
            modal: false
        };
    },
    methods: {
        showForumHandler() {
            this.modal = true;
        },
        handleContentClick(forum) {
            if (this.content.lock) return;
            if (forum) {
                return this.showForumHandler();
            } else {
                return (window.location.href = this.url);
            }
        }
    },
    computed: {
        formatedStartDate() {
            const startDate = new Date(this.content.exercise_publish.start_date);

            const formattedDate = startDate.toISOString().split('T')[0];

            const formattedTime = startDate.toTimeString().split(' ')[0];

            const translation = this.$t('common.at');

            const formattedDateTimeWithSuffix = `${formattedDate} ${translation} ${formattedTime}`;

            return formattedDateTimeWithSuffix;
        },
        formatedEndDate() {
            const endDate = new Date(this.content.exercise_publish.end_date);

            const formattedEndDate = endDate.toISOString().split('T')[0];

            const formattedEndTime = endDate.toTimeString().split(' ')[0];

            const translation = this.$t('common.at');

            const formattedEndDateTimeWithSuffix = `${formattedEndDate} ${translation} ${formattedEndTime}`;

            return formattedEndDateTimeWithSuffix;
        },
        scheduleContent() {
            if (this.content.lock_type === 'SCHEDULE') {
                if (this.content.exercise_publish && new Date(this.content.exercise_publish.start_date) > new Date() && this.content.exercise_publish.start_date != null) {
                    return `${this.$t('exercise.publish.schedule')} ${this.formatedStartDate} ${this.$t('common.and')} ${this.formatedEndDate}`;
                } else if (this.content.exercise_publish && new Date(this.content.exercise_publish.end_date) < new Date() && this.content.exercise_publish.end_date != null) {
                    return `${this.$t('exercise.publish.schedule_end')} ${this.formatedEndDate}<br>${this.$t('common.final_grade')} ${this.content.exercise_grades}`;
                }
            }

            if (this.content.lock_type === 'AVAILABLE' && this.content.exercise_publish.start_date === null && this.content.exercise_publish.end_date === null) {
                return '';
            }

            if (this.content.exercise_publish.start_date === null && this.content.exercise_publish.end_date === null && this.content.lock_type !== 'AVAILABLE') {
                return this.$t('common.blocked');
            }

            return this.$t('common.blocked');
        },
        color() {
            return this.$store.getters.COLOR;
        },
        queryParam() {
            return this.submodules
                .map(sub => {
                    return `submodules%5B%5D=${sub}`;
                })
                .toString()
                .replace(",", "&");
        }
    },
    mounted() {
        this.url = `${this.courseId}`;
        if (this.moduleId) {
            this.url = `${this.url}/module/${this.parentId}/exercise/${this.content.id}?${this.queryParam}`;
        } else {
            this.url = `${this.url}/exercise/${this.content.id}`;
        }
    }
};
</script>

<style scoped>
.forum {
    filter: grayscale(0);
    transition: all 0.2s ease-in;
    cursor: pointer;
}
.forum:hover {
    filter: grayscale(0.5);
}

h4 {
    margin: 0;
    padding: 0;
}
</style>
